var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.644,
    height: 13,
    viewBox: "0 0 14.644 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "warning-triangle",
    d: "M6.348-6.17A.242.242,0,0,1,6.424-6.4a.316.316,0,0,1,.229-.1H8.023a.318.318,0,0,1,.165.038.269.269,0,0,1,.1.114.393.393,0,0,1,.038.178L8.176-3.326a.411.411,0,0,1-.114.19.267.267,0,0,1-.19.089H6.8a.273.273,0,0,1-.3-.279ZM8.074-2.361a.966.966,0,0,1,.33.736,1.024,1.024,0,0,1-.317.749,1.024,1.024,0,0,1-.749.317,1.024,1.024,0,0,1-.749-.317,1.024,1.024,0,0,1-.317-.749,1.024,1.024,0,0,1,.317-.749,1.024,1.024,0,0,1,.749-.317A.966.966,0,0,1,8.074-2.361Zm.33-8.4L14.5-.2a1.188,1.188,0,0,1-.013,1.219,1.13,1.13,0,0,1-1.054.609H1.244A1.13,1.13,0,0,1,.19,1.016,1.188,1.188,0,0,1,.178-.2L6.271-10.766a1.157,1.157,0,0,1,1.066-.609A1.157,1.157,0,0,1,8.4-10.766ZM1.371.178Q1.244.406,1.5.406h11.68A.149.149,0,0,0,13.3.33a.127.127,0,0,0,0-.152L7.465-9.928A.149.149,0,0,0,7.338-10a.149.149,0,0,0-.127.076Z",
    transform: "translate(-0.016 11.375)",
    fill: "#fa9f47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.4bf37e537a5c8e37a97f4d506c49f865.svg";
export { ForwardRef as ReactComponent };